module.exports = (__webpack_require__(/*! dll-reference umi */ "dll-reference umi"))("./src/pages/.umi/history.js");